<template>
  <b-modal :ref="modalRef" :id="modalId" :title="title" hide-footer>
    <div>
      <p
        v-for="formItem of formsData"
        :key="formItem.id"
        class="text-no-wrap flex justify-content-between"
      >
        <span class="text-info" style="flex: 30%"
          >{{ formItem?.employeeName }}
          {{ formItem.employeeCode ? `(${formItem?.employeeCode})` : '' }}</span
        >
        <span class="text-success ml-2" style="flex: 35%">{{
          formItem.currentStoreName
        }}</span>
        <span class="text-danger ml-2" style="flex: 35%"
          >-> {{ formItem.targetStoreName }}</span
        >
      </p>
    </div>
    <div class="d-flex justify-content-start">
      <b-button @click="handleCancel" variant="primary" size="sm"
        >Quay lại</b-button
      >
      <b-button
        @click="handleConfirm"
        :variant="confirmButtonVariant"
        class="ml-3"
        size="sm"
        >{{ confirmButtonText }}</b-button
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TransferStoreFormManyItemsModal',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    formsData: {
      type: Array,
      default: () => [],
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    confirmButtonVariant: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    modalRef() {
      return this.modalId.replace(/-/g, '_');
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    show() {
      this.$bvModal.show(this.modalId);
    },
    hide() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
